import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['toggle', 'body', 'count', 'clear']

  connect() {
    if (!this.hasBodyTarget) return

    this.recount = this.recount.bind(this)
    this.bodyTarget.addEventListener('input',  this.recount)
    this.bodyTarget.addEventListener('change', this.recount)
    // The comboboxes are React: their hidden inputs change without firing events.
    this.observer = new MutationObserver(this.recount)
    this.observer.observe(this.bodyTarget, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['value']
    })
    this.recount()
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  toggle() {
    this.setOpen(this.bodyTarget.hidden)
  }

  reset() {
    if (!this.hasBodyTarget) return

    this.setOpen(false)
    setTimeout(this.recount)
  }

  clear() {
    const within = role => this.bodyTarget.querySelectorAll(`[data-target~="forms--clear-filters.${role}"]`)

    within('input').forEach(input => input.value = '')
    within('toggle').forEach(element => { element.value = ''; element.classList.add('d-none') })
    within('react').forEach(component => component.querySelectorAll('input').forEach(input => input.value = ''))
    within('reset').forEach(component => {
      const reset = component.querySelector('.combobox__multiple__reset, .autocomplete__reset')
      if (reset) reset.click()
    })
    setTimeout(this.recount)
  }

  recount() {
    const count = this.activeCount()
    this.countTarget.textContent = count
    this.countTarget.hidden      = count === 0
    this.clearTarget.hidden      = count === 0
  }

  setOpen(open) {
    this.bodyTarget.hidden = !open
    this.toggleTarget.setAttribute('aria-expanded', open)
    this.element.querySelector('.ivf-client-section').classList.toggle('is-open', open)
  }

  // A period type with no dates filters nothing.
  // Property field id inputs are always set: only their answers filter.
  activeCount() {
    const values = {}
    this.bodyTarget.querySelectorAll('input[name^="clients_filter_form["]').forEach((input, index) => {
      if (input.value === '' || input.disabled) return
      if (/\[(property_field_id|extra_field_id)\]$/.test(input.name)) return

      const key = input.name.includes('[property_fields_answers][]') ? `${input.name}#${index}` : input.name.replace(/\[\]$/, '')
      values[key] = true
    })
    const period = 'clients_filter_form[period]'
    if (!values[period]) delete values['clients_filter_form[period_type]']

    return Object.keys(values).length
  }
}
